import { useConfigContext, useTranslationsContext } from '../../context';

import { ErrorBoundaryFallbackProps } from './types';

type Props = ErrorBoundaryFallbackProps;

const ErrorFallback: React.FC<Props> = ({ error }) => {
  const translations = useTranslationsContext();
  const config = useConfigContext();

  return (
    <div>
      <h2>{translations.general.somethingWentWrong}</h2>
      {config.isDevMode && error?.message ? <p>{error.message}</p> : null}
    </div>
  );
};

export default ErrorFallback;
